module.exports = __webpack_public_path__ + "static/img/Bachelor_010605.446fe15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010605.jpg
// module id = 198
// module chunks = 0